import { useEffect } from 'react';

const WIDGET_CONFIG = {
  apiKey:
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhaUlkIjoiMTc3OTY5MzkyNjI0My0wZGFmNDBiMiIsInVzZXJJZCI6IjE3Nzk2OTI2NzcwNTQtNjdiNmIzZTUiLCJ0eXBlIjoid2lkZ2V0IiwiaWF0IjoxNzc5NjkzOTI4LCJleHAiOjE4MTEyMjk5Mjh9.5hu0kJPRl5OFwXOjFe-Fw23K9fy-niojcS47cfadkh0',
  assistantId: '1779693926243-0daf40b2',
  apiEndpoint: 'https://rafikiaicompany.com',
  autoFetchConfig: true,
  autoRefreshInterval: 0,
  fallbackConfig: {
    title: 'Ablconstruction',
    subtitle: 'Customer Care',
    welcomeMessage: 'Hello! How can I assist you today?',
    logoUrl:
      'https://rafikiaicompany.com/uploads/widget-logos/1779693923292-samplelogo.jpeg',
    primaryColor: '#ffffff',
    position: 'bottom-right',
    showBranding: true,
    allowTranscript: true,
    allowAttachments: false,
  },
  debug: false,
};

const SCRIPT_SELECTOR = 'script[src*="chat-widget.js"]';
const SCRIPT_BASE = 'https://rafikiaicompany.com/widget/chat-widget.js';

function initRafikiWidget() {
  if (window.RafikiChat && typeof window.RafikiChat.init === 'function') {
    try {
      window.RafikiChat.init(WIDGET_CONFIG);
    } catch (error) {
      console.error('Rafiki Chat Widget: Initialization error', error);
    }
    return;
  }

  const existingScript = document.querySelector(SCRIPT_SELECTOR);
  if (existingScript) {
    const checkInterval = setInterval(() => {
      if (window.RafikiChat && typeof window.RafikiChat.init === 'function') {
        clearInterval(checkInterval);
        try {
          window.RafikiChat.init(WIDGET_CONFIG);
        } catch (error) {
          console.error('Rafiki Chat Widget: Initialization error', error);
        }
      }
    }, 100);

    setTimeout(() => clearInterval(checkInterval), 10000);
    return;
  }

  const script = document.createElement('script');
  script.src = `${SCRIPT_BASE}?v=latest&t=${Date.now()}`;
  script.async = true;
  script.defer = true;
  script.dataset.rafikiWidget = 'abl-construction';

  let retryCount = 0;
  const maxRetries = 10;

  function tryInit() {
    if (window.RafikiChat && typeof window.RafikiChat.init === 'function') {
      try {
        window.RafikiChat.init(WIDGET_CONFIG);
      } catch (error) {
        console.error('Rafiki Chat Widget: Initialization error', error);
      }
    } else if (retryCount < maxRetries) {
      retryCount += 1;
      setTimeout(tryInit, 200);
    } else {
      console.error(
        `Rafiki Chat Widget: Failed to initialize after ${maxRetries} attempts.`
      );
    }
  }

  script.onload = () => setTimeout(tryInit, 100);

  script.onerror = () => {
    console.error(`Rafiki Chat Widget: Failed to load script from ${SCRIPT_BASE}`);
  };

  if (document.head) {
    document.head.appendChild(script);
  } else if (document.body) {
    document.body.appendChild(script);
  }
}

function RafikiChatWidget() {
  useEffect(() => {
    initRafikiWidget();
  }, []);

  return null;
}

export default RafikiChatWidget;
